import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { company } from "../constants";
import "../Roboto-VariableFont_wdth,wght-normal.js";

export const generateInvoice = (order) => {
  const products = order?.products;
  if (!products || !Array.isArray(products)) {
    console.error("Invalid order data");
    return;
  }

  const doc = new jsPDF();

  const companyName = "The Zaik";
  const companyAddress = company.address;

  // User Details
  const user = order?.address || {};
  const userName = user?.name;
  const userAddress = `${user?.address}, ${user?.pin}`;
  const userPhone = user?.phone;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);

  // Get page width to center the text
  const pageWidth = doc.internal.pageSize.getWidth();
  const title = "Invoice";
  const textWidth = doc.getTextWidth(title);

  // Calculate X position to center the text
  const x = (pageWidth - textWidth) / 2;

  // Y position near the top (e.g., 20)
  doc.text(title, x, 20);

  // Invoice Header
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(companyName, 10, 15);
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text(companyAddress, 10, 20);

  // Invoice Details
  doc.text(`Invoice : ${order?.orderId}`, 150, 15);
  doc.text(
    `Created: ${new Date(order?.createdAt).toLocaleDateString()}`,
    150,
    20
  );

  // User Information
  doc.setFont("helvetica", "bold");
  doc.text("Billing Details:", 10, 35);
  doc.setFont("helvetica", "normal");
  doc.text(`Name: ${userName}`, 10, 40);
  doc.text(`Address: ${userAddress}`, 10, 45);
  doc.text(`Phone: ${userPhone}`, 10, 50);

  // Payment Method
  doc.setFont("helvetica", "bold");
  doc.text("Payment Method:", 150, 35);
  doc.setFont("helvetica", "normal");
  doc.text(`${order?.paymentMethod.toUpperCase()}`, 150, 40);

  // Order Items Table
  const tableData = products.map((item) => [
    item.productName,
    item.quantity,
    `₹${item.price}`,
    `₹${item.price * item.quantity}`,
  ]);
  const total = products.reduce(
    (acc, curr) => acc + curr.price * curr.quantity,
    0
  );
  autoTable(doc, {
    startY: 60,
    head: [["Product", "Qty", "Unit Price", "Total Price"]],
    body: tableData,
    theme: "grid",
    styles: { fontSize: 10, font: "Roboto-VariableFont_wdth,wght" },
    headStyles: { fillColor: [50, 50, 50] },
    columnStyles: {
      0: { cellWidth: 60 },
      1: { cellWidth: 50 },
      2: { cellWidth: 20, halign: "center" },
      3: { cellWidth: 30, halign: "right" },
      4: { cellWidth: 30, halign: "right" },
    },
  });

  // Total Amount
  const finalY = doc.lastAutoTable.finalY;

  //   doc.text(
  //     `Shipping Charge: ${order?.deliveryCharge || "0.00"}`,
  //     150,
  //     finalY + 20
  //   );
  //   doc.text(
  //     `Total Discount Saved: ${order?.totalDiscountedAmount.toFixed(2)}`,
  //     150,
  //     finalY + 25
  //   );
  doc.setFont("Roboto-VariableFont_wdth,wght", "normal");
  doc.text(`Grand Total: ₹${total}`, 150, finalY + 30);
  doc.text(`Total Paid: ₹${total}`, 150, finalY + 35);
  // Order Status
  // const statusY = finalY + 30;
  //   const status = order?.orderStatus || {};
  // doc.setFont("helvetica", "bold");
  // doc.text("Order Status:", 10, statusY);
  // doc.setFont("helvetica", "normal");
  //   doc.text(
  //     `Shipped: ${
  //       status.shipped.isShipped
  //         ? `Yes (Tracking ID: ${status.shipped.trackingId})`
  //         : "No"
  //     }`,
  //     10,
  //     statusY + 5
  //   );
  //   doc.text(
  //     `Out for Delivery: ${
  //       status.outForDelivery.isOutForDelivery ? "Yes" : "No"
  //     }`,
  //     10,
  //     statusY + 10
  //   );
  //   doc.text(
  //     `Delivered: ${status.delivered.isDelivered ? "Yes" : "No"}`,
  //     10,
  //     statusY + 15
  //   );

  // Save PDF
  doc.save(`Invoice_${order?.orderId}.pdf`);
};
